var _jsxFileName = "/Users/pjreed/dev/mirador/dist/es/src/components/OpenSeadragonViewer.js";

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import OpenSeadragon from 'openseadragon';
import classNames from 'classnames';
import ns from '../config/css-ns';
import OpenSeadragonCanvasOverlay from '../lib/OpenSeadragonCanvasOverlay';
import CanvasWorld from '../lib/CanvasWorld';
import CanvasAnnotationDisplay from '../lib/CanvasAnnotationDisplay';
/**
 * Represents a OpenSeadragonViewer in the mirador workspace. Responsible for mounting
 * and rendering OSD.
 */

export var OpenSeadragonViewer =
/*#__PURE__*/
function (_Component) {
  _inherits(OpenSeadragonViewer, _Component);

  _createClass(OpenSeadragonViewer, null, [{
    key: "annotationsMatch",

    /**
     * annotationsMatch - compares previous annotations to current to determine
     * whether to add a new updateCanvas method to draw annotations
     * @param  {Array} currentAnnotations
     * @param  {Array} prevAnnotations
     * @return {Boolean}
     */
    value: function annotationsMatch(currentAnnotations, prevAnnotations) {
      if (currentAnnotations.length === 0 && prevAnnotations.length === 0) return true;
      if (currentAnnotations.length !== prevAnnotations.length) return false;
      return currentAnnotations.every(function (annotation, index) {
        var newIds = annotation.resources.map(function (r) {
          return r.id;
        });
        var prevIds = prevAnnotations[index].resources.map(function (r) {
          return r.id;
        });
        if (newIds.length === 0 && prevIds.length === 0) return true;
        if (newIds.length !== prevIds.length) return false;

        if (annotation.id === prevAnnotations[index].id && isEqual(newIds, prevIds)) {
          return true;
        }

        return false;
      });
    }
    /**
     * @param {Object} props
     */

  }]);

  function OpenSeadragonViewer(props) {
    var _this;

    _classCallCheck(this, OpenSeadragonViewer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OpenSeadragonViewer).call(this, props));
    _this.viewer = null;
    _this.osdCanvasOverlay = null; // An initial value for the updateCanvas method

    _this.updateCanvas = function () {};

    _this.ref = React.createRef();
    _this.onUpdateViewport = _this.onUpdateViewport.bind(_assertThisInitialized(_this));
    _this.onViewportChange = _this.onViewportChange.bind(_assertThisInitialized(_this));
    _this.zoomToWorld = _this.zoomToWorld.bind(_assertThisInitialized(_this));
    _this.osdUpdating = false;
    return _this;
  }
  /**
   * React lifecycle event
   */


  _createClass(OpenSeadragonViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          osdConfig = _this$props.osdConfig,
          viewer = _this$props.viewer;

      if (!this.ref.current) {
        return;
      }

      this.viewer = new OpenSeadragon(_objectSpread({
        id: this.ref.current.id
      }, osdConfig));
      this.osdCanvasOverlay = new OpenSeadragonCanvasOverlay(this.viewer);
      this.viewer.addHandler('update-viewport', this.onUpdateViewport); // Set a flag when OSD starts animating (so that viewer updates are not used)

      this.viewer.addHandler('animation-start', function () {
        _this2.osdUpdating = true;
      });
      this.viewer.addHandler('animation-finish', this.onViewportChange);
      this.viewer.addHandler('animation-finish', function () {
        _this2.osdUpdating = false;
      });
      this.updateCanvas = this.canvasUpdateCallback();

      if (viewer) {
        this.viewer.viewport.panTo(viewer, true);
        this.viewer.viewport.zoomTo(viewer.zoom, viewer, true);
      }

      this.addAllTileSources();
    }
    /**
     * When the tileSources change, make sure to close the OSD viewer.
     * When the annotations change, reset the updateCanvas method to make sure
     * they are added.
     * When the viewport state changes, pan or zoom the OSD viewer as appropriate
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          viewer = _this$props2.viewer,
          highlightedAnnotations = _this$props2.highlightedAnnotations,
          selectedAnnotations = _this$props2.selectedAnnotations,
          searchAnnotations = _this$props2.searchAnnotations,
          selectedContentSearchAnnotations = _this$props2.selectedContentSearchAnnotations;
      var highlightsUpdated = !OpenSeadragonViewer.annotationsMatch(highlightedAnnotations, prevProps.highlightedAnnotations);
      var selectionsUpdated = !OpenSeadragonViewer.annotationsMatch(selectedAnnotations, prevProps.selectedAnnotations);
      var searchAnnotationsUpdated = !OpenSeadragonViewer.annotationsMatch(searchAnnotations, prevProps.searchAnnotations);
      var selectedContentSearchAnnotationsUpdated = !OpenSeadragonViewer.annotationsMatch(selectedContentSearchAnnotations, prevProps.selectedContentSearchAnnotations);

      if (searchAnnotationsUpdated || selectedContentSearchAnnotationsUpdated || highlightsUpdated || selectionsUpdated) {
        this.updateCanvas = this.canvasUpdateCallback();
        this.viewer.forceRedraw();
      }

      if (!this.tileSourcesMatch(prevProps.tileSources)) {
        this.viewer.close();
        this.addAllTileSources();
      } else if (viewer && !this.osdUpdating) {
        var viewport = this.viewer.viewport;

        if (viewer.x !== viewport.centerSpringX.target.value || viewer.y !== viewport.centerSpringY.target.value) {
          this.viewer.viewport.panTo(viewer, false);
        }

        if (viewer.zoom !== viewport.zoomSpring.target.value) {
          this.viewer.viewport.zoomTo(viewer.zoom, viewer, false);
        }
      }
    }
    /**
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.viewer.removeAllHandlers();
    }
    /**
     * onUpdateViewport - fires during OpenSeadragon render method.
     */

  }, {
    key: "onUpdateViewport",
    value: function onUpdateViewport(event) {
      this.updateCanvas();
    }
    /**
     * Forward OSD state to redux
     */

  }, {
    key: "onViewportChange",
    value: function onViewportChange(event) {
      var _this$props3 = this.props,
          updateViewport = _this$props3.updateViewport,
          windowId = _this$props3.windowId;
      var viewport = event.eventSource.viewport;
      updateViewport(windowId, {
        x: Math.round(viewport.centerSpringX.target.value),
        y: Math.round(viewport.centerSpringY.target.value),
        zoom: viewport.zoomSpring.target.value
      });
    }
    /** */

  }, {
    key: "canvasUpdateCallback",
    value: function canvasUpdateCallback() {
      var _this3 = this;

      return function () {
        _this3.osdCanvasOverlay.clear();

        _this3.osdCanvasOverlay.resize();

        _this3.osdCanvasOverlay.canvasUpdate(_this3.renderAnnotations.bind(_this3));
      };
    }
    /**
     * annotationsToContext - converts anontations to a canvas context
     */

  }, {
    key: "annotationsToContext",
    value: function annotationsToContext(annotations) {
      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yellow';
      var canvasWorld = this.props.canvasWorld;
      var context = this.osdCanvasOverlay.context2d;
      var zoom = this.viewer.viewport.getZoom(true);
      annotations.forEach(function (annotation) {
        annotation.resources.forEach(function (resource) {
          if (!canvasWorld.canvasIds.includes(resource.targetId)) return;
          var offset = canvasWorld.offsetByCanvas(resource.targetId);
          var canvasAnnotationDisplay = new CanvasAnnotationDisplay({
            color: color,
            offset: offset,
            resource: resource,
            zoom: zoom
          });
          canvasAnnotationDisplay.toContext(context);
        });
      });
    }
    /** */

  }, {
    key: "addAllTileSources",
    value: function addAllTileSources() {
      var _this4 = this;

      var tileSources = this.props.tileSources;
      Promise.all(tileSources.map(function (tileSource, i) {
        return _this4.addTileSource(tileSource, i);
      })).then(function () {
        if (tileSources[0]) {
          _this4.zoomToWorld();
        }
      });
    }
    /**
     */

  }, {
    key: "addTileSource",
    value: function addTileSource(tileSource) {
      var _this5 = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var canvasWorld = this.props.canvasWorld;
      return new Promise(function (resolve, reject) {
        if (!_this5.viewer) {
          return;
        }

        _this5.viewer.addTiledImage({
          error: function error(event) {
            return reject(event);
          },
          fitBounds: _construct(OpenSeadragon.Rect, _toConsumableArray(canvasWorld.canvasToWorldCoordinates(i))),
          success: function success(event) {
            return resolve(event);
          },
          tileSource: tileSource
        });
      });
    }
    /**
     */

  }, {
    key: "fitBounds",
    value: function fitBounds(x, y, w, h) {
      var immediately = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      this.viewer.viewport.fitBounds(new OpenSeadragon.Rect(x, y, w, h), immediately);
    }
    /**
     * tileSourcesMatch - compares previous tileSources to current to determine
     * whether a refresh of the OSD viewer is needed.
     * @param  {Array} prevTileSources
     * @return {Boolean}
     */

  }, {
    key: "tileSourcesMatch",
    value: function tileSourcesMatch(prevTileSources) {
      var tileSources = this.props.tileSources;
      if (tileSources.length === 0 && prevTileSources.length === 0) return true;
      return tileSources.some(function (tileSource, index) {
        if (!prevTileSources[index]) {
          return false;
        }

        if (tileSource['@id'] === prevTileSources[index]['@id']) {
          return true;
        }

        return false;
      });
    }
    /**
     * zoomToWorld - zooms the viewer to the extent of the canvas world
     */

  }, {
    key: "zoomToWorld",
    value: function zoomToWorld() {
      var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var canvasWorld = this.props.canvasWorld;
      this.fitBounds.apply(this, _toConsumableArray(canvasWorld.worldBounds()).concat([immediately]));
    }
    /** */

  }, {
    key: "renderAnnotations",
    value: function renderAnnotations() {
      var _this$props4 = this.props,
          searchAnnotations = _this$props4.searchAnnotations,
          selectedContentSearchAnnotations = _this$props4.selectedContentSearchAnnotations,
          highlightedAnnotations = _this$props4.highlightedAnnotations,
          selectedAnnotations = _this$props4.selectedAnnotations,
          palette = _this$props4.palette;
      this.annotationsToContext(searchAnnotations, palette.highlights.secondary);
      this.annotationsToContext(selectedContentSearchAnnotations, palette.highlights.primary);
      this.annotationsToContext(highlightedAnnotations, palette.highlights.secondary);
      this.annotationsToContext(selectedAnnotations, palette.highlights.primary);
    }
    /**
     * Renders things
     */

  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          classes = _this$props5.classes,
          label = _this$props5.label,
          t = _this$props5.t,
          windowId = _this$props5.windowId;
      var enhancedChildren = React.Children.map(children, function (child) {
        return React.cloneElement(child, {
          zoomToWorld: _this6.zoomToWorld
        });
      });
      return React.createElement(React.Fragment, null, React.createElement("section", {
        className: classNames(ns('osd-container'), classes.osdContainer),
        id: "".concat(windowId, "-osd"),
        ref: this.ref,
        "aria-label": t('item', {
          label: label
        }),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 307
        },
        __self: this
      }, enhancedChildren));
    }
  }]);

  return OpenSeadragonViewer;
}(Component);
OpenSeadragonViewer.defaultProps = {
  children: null,
  highlightedAnnotations: [],
  label: null,
  osdConfig: {},
  palette: {},
  searchAnnotations: [],
  selectedAnnotations: [],
  selectedContentSearchAnnotations: [],
  tileSources: [],
  viewer: null
};